// extracted by mini-css-extract-plugin
export default {"benefit-info-text":"z6VBp_benefit-info-text"};